export default __webpack_public_path__ + "static/media/slot.4c09125e.svg";